
import React, { CSSProperties, useEffect, useState } from 'react'
import { CountryIso2, CountrySelector } from 'react-international-phone'
import { GeneralMethods } from '../../Structure/Handlers/GeneralMethods';
import 'react-international-phone/style.css';

const CustomPhoneInput:React.FC<{className:string,inputClassName?:string,disabled?:boolean,countryKey?:string,country?:string ,placeholder?:string,value?:string,setCountryKey?:(key:string)=>void, setCountry?:(country:CountryIso2)=>void , setNumber?:(key:string)=>void ,setFullNumber?:(numb:string)=>void, style?:CSSProperties , selectorStyle?:CSSProperties, inputStyle?:CSSProperties}> = (props) => {

  //states  
  const [selectedCountry, setSelectedCountry] = useState<CountryIso2>(props.country || GeneralMethods.getCountryFromDialCode(props.countryKey||'1') || 'us');
  const [mobileNumber , setMobileNumber] = useState<string>(props.value||'')
  const [countryKey , setCountryKey] = useState<string>(props.country||'1')
  //functions
  const validateNumber = (input:string)=>{
    const regex = /^[0-9]*$/;
    var res = mobileNumber
    if(input.length>0){
      if(regex.test(input[input.length-1])){
        res = input
      }
      if(input === "0") res=''
    }else res =''
    setMobileNumber(res)
  }

  //effects
  useEffect(()=>{ if(props.setNumber)props.setNumber(mobileNumber); if(props.setFullNumber && mobileNumber)props.setFullNumber('+'+countryKey+mobileNumber) },[mobileNumber])

  return (
    <div className={`${props.className} p-0`} style={{display:'flex',...props.style}}>
    <CountrySelector
      disabled = {props.disabled}
      style={{...props.selectorStyle, display:'inline-block',height:'100%'}}
      selectedCountry={selectedCountry} // استخدام الخاصية الصحيحة
      onSelect={(country) => {  setSelectedCountry(country.iso2); if(props.setCountry) props.setCountry(country.iso2); setCountryKey(country.dialCode); if(props.setCountryKey)props.setCountryKey(country.dialCode)}} // تحديد دالة تغيير الدولة
    />
    <input  disabled = {props.disabled} className={`${props.inputClassName} h-100 my-auto p-1 px-3`} placeholder={props.placeholder} value={mobileNumber} onChange={(a)=>validateNumber(a.target.value)} style={{position:'relative' , height:'100%' , width:'100%' ,margin:'0px auto', padding:'0px 5px' , border:'none' , outline:'none' ,background:'none', ...props.inputStyle}}></input>
      </div>
  )
}

export default CustomPhoneInput
